<template>
        <widget :title="title" :router="router">
            <div class="warp_main">
                <div class="count">
                    <div class="count_ceil">
                        <i></i>
                        <span>课程数量：<strong>{{courseNum}}</strong></span>
                    </div>
                    <div class="count_ceil">
                        <i></i>
                        <span>班级数量：<strong>{{calssNum}}</strong></span>
                    </div>
                    <span class="unit">单位/学期</span>
                </div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>课时项</th>
                            <th>总学时</th>
                            <th>理论学时</th>
                            <th>实训学时</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(course,index) in tableData" :key="index">
                            <td>{{course.name}}</td>
                            <td>{{course.totalHours || 0}}</td>
                            <td>{{course.theoryHours || 0}}</td>
                            <td>{{course.practiceHours || 0}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>  
        </widget>
    </template>
    <script>
        import widget from './zj_warp'
        import widgetFilter from './widgetFilter.js'
        export default {
            components: {
                widget
            },
            props:{
                title:{
                    type:String
                },
                swWidth:{
                    type:Number,
                    default:1
                },
                item:{
                    type:Object
                }
            },
            filters:{
                format:function(val){
                    return '.'+val.split('.')[1]
                }
            },
            data(){
                return {
                    widgetType:1,
                    router:'edumanage_teaching_class_list',
                    tableData:[],
                    courseNum:0,
                    calssNum:0,
                    configList:null,
                    teacherId:window.appframe.$store.state.userInfo.id
                }
            },
            mounted(){
                let vm = this
                vm.$nextTick(function(){
                    vm.widgetType = _.cloneDeep(vm.swWidth)
                    if(vm.item.configList.length > 0){
                        let configList = vm.item.configList
                        vm.configList = widgetFilter.getFieldMap(configList)
                        let stemp = []
                        for(let i in vm.configList){
                            stemp.push(vm.configList[i])
                        }
                        let widgetUrl = stemp[0].apiUrl
                        vm.query(widgetUrl)
                    }
                })
            },
            methods: {
                query(widgetUrl){
                    let vm = this
                    http.get('/gateway/edumanage/teaching/teacherTask/teachWorkload?teacherId='+vm.teacherId).then(function(xhr){
                        let objectA = xhr.data.data
                        let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                        var newObj = new Object();
                        let tableData = widgetFilter.showProps(objectA,'',simpleMap,newObj)

                        vm.courseNum = tableData.plan ? tableData.plan.courseCount : 0
                        vm.calssNum = tableData.plan ? tableData.plan.classCount : 0
                        let arr = {
                            plan:'计划学时',
                            overArrange:'上课学时',
                            allArrange:'排课学时',
                            adjust:'调课学时',
                            stop:'停课学时',
                        }
                        for(let i in tableData){
                            if(!tableData[i]){
                                tableData[i] = new Object()
                            }
                            tableData[i].ename = i
                            tableData[i].name = arr[i]
                            vm.tableData.push(tableData[i])
                        }
                    })
                },
                getTab(data){
                    let vm = this
                }
            }
        }
    </script>
    <style scoped lang="less">
        .warp_main{
            padding: 20px;
        }
        .count{
            border-bottom:1px solid #E5E7EA;
            line-height: 30px;
            .count_ceil{
                display: inline-block;
                margin-right:45px;
                i{
                    width: 6px;
                    height: 6px;
                    display: inline-block;
                    vertical-align: middle;
                }
                strong{
                    font-size: 18px;
                }
            }
            .unit{
                float: right;
            }
            .count_ceil:nth-child(1){
                color: #4CB7FE;
                i{
                    background:#4CB7FE;
                }
            }
            .count_ceil:nth-child(2){
                color: #61e6ca;
                i{
                    background:#61e6ca;
                }
            }
        }
        .table{
            width: 100%;
            margin-top: 20px;
            font-size: 12px;
            tr{
                height: 30px;
                td,th{
                    border:1px solid #E5E7EA;
                    text-align: center;
                }
                td:nth-child(1),
                th{
                    background: #EDF3FE;
                }
                
            }
        }
    </style>


// WEBPACK FOOTER //
// src/components/homepage/widget/zj_teacher_workload.vue